<template>
  <div
    class="banner-carousel"
    @mouseenter="mouseOver = true"
    @mouseleave="mouseOver = false"
  >
    <v-window
      continuous
      :show-arrows="!$vuetify.breakpoint.mobile && images.length > 1"
      v-model="onboarding"
      class="banner-window"
      eager
    >
      <v-window-item
        v-for="(item, index) in images"
        :key="index"
        class="banner-item"
        eager
      >
        <div class="d-flex justify-center align-stretch">
          <a
            :class="['banner-link', item.url ? 'hyperlink' : 'disabled-link']"
            v-bind="
              item.url ? { href: item.url, rel: 'noreferrer noopener' } : {}
            "
          >
            <v-img
              :src="item.img"
              contain
              eager
              :height="$vuetify.breakpoint.mobile ? '70vw' : '33vw'"
              :max-height="$vuetify.breakpoint.mobile ? '800px' : '600px'"
              class="banner-image"
              style="object-position: top; height: 100%"
            />
          </a>
        </div>
      </v-window-item>
    </v-window>
    
    <!-- Barra de indicadores -->
    <div v-if="images.length > 1" class="banner-indicators-background">
      <div class="banner-indicators-container">
        <div 
          v-for="(_, i) in images" 
          :key="i"
          class="banner-indicator"
          :class="{ active: onboarding === i }"
          @click="onboarding = i"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannersCarousel',

  props: {
    images: {
      type: Array,
      required: true
    },
    transitionTime: {
      type: Number,
      default: 5000
    }
  },

  data () {
    return {
      onboarding: 0,
      intervalId: null,
      mouseOver: false
    }
  },

  mounted () {
    this.startAutoSlide()
  },

  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  watch: {
    images () {
      this.startAutoSlide()
    },
    onboarding () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      this.startAutoSlide()
    },
    transitionTime: {
      handler () {
        this.startAutoSlide()
      },
      immediate: true
    }
  },

  methods: {
    startAutoSlide () {
      if (this.images.length <= 1) {
        return
      }

      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      this.intervalId = setInterval(() => {
        if (this.mouseOver) {
          return
        }
        this.onboarding = (this.onboarding + 1) % this.images.length
      }, this.transitionTime)
    }
  }
}
</script>

<style scoped>
.banner-carousel {
  position: relative;
  overflow: hidden;
  background-color: #e8e8e8;
}

@media (max-width: 600px) {
  .banner-carousel {
    margin: 0;
    box-shadow: none;
  }
}

.banner-item {
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.banner-link {
  display: block;
  width: 100%;
}

.banner-image {
  filter: brightness(1.02);
}

.hyperlink {
  color: var(--v-texto-base) !important;
  text-decoration: none;
}

.disabled-link {
  cursor: default;
  pointer-events: none;
}

.banner-slide {
  padding: 0;
  display: flex;
  align-items: flex-start;
}

/* Estilos para os indicadores de navegação */
.banner-indicators-background {
  width: 100%;
  background-color: #e8e8e8;
  padding: 10px 0;
}

.banner-indicators-container {
  display: flex;
  justify-content: center;
  position: relative;
  gap: 12px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.banner-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(180, 180, 180, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
}

.banner-indicator.active {
  background-color: #1976d2;
  transform: scale(1.25);
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.4);
}
</style>
